import { createReducer, on } from '@ngrx/store';
import {
  signInRequest,
  signInSuccess,
  signInFailure,
  setDataRequest,
  setDataSuccess,
  setDataFailure,
  getUserDataRequest,
  getUserDataSuccess,
  getUserDataFailure,
  logout,
} from '../actions/user.actions';

export interface UserState {
  loading: boolean;
  message: string;
  user: any;
  tokenInfo: any;
  refreshTokenInfo: any;
}

export const initialState: UserState = {
  loading: false,
  message: '',
  user: {},
  tokenInfo: {},
  refreshTokenInfo: {},
};

export const userReducer = createReducer(
  initialState,
  on(signInRequest, (state) => ({
    ...state,
    loading: true,
    message: ''
  })),
  on(signInSuccess, (state, { data, message }) => ({
    ...state,
    loading: false,
    message,
    user: data.user,
    tokenInfo: data.tokenInfo,
    refreshTokenInfo: data.refreshTokenInfo
  })),
  on(signInFailure, (state, { message }) => ({
    ...state,
    loading: false,
    message
  })),
  on(setDataRequest, (state) => ({
    ...state,
    loading: true,
    message: ''
  })),
  on(setDataSuccess, (state, { data }) => ({
    ...state,
    loading: false,
    user: data.user,
    tokenInfo: data.tokenInfo,
    refreshTokenInfo: data.refreshTokenInfo
  })),
  on(setDataFailure, (state, { message }) => ({
    ...state,
    loading: false,
    message
  })),
  on(getUserDataRequest, (state) => ({
    ...state,
    loading: true,
    message: ''
  })),
  on(getUserDataSuccess, (state, { data }) => ({
    ...state,
    loading: false,
    user: data
  })),
  on(getUserDataFailure, (state, { message }) => ({
    ...state,
    loading: false,
    message
  })),
  on(logout, () => initialState),
);
